import { useCallback } from 'react';

import { usePsfSharePageState } from 'src/app/pages/psf/share/pageContext';
import type { ShareChannel } from 'src/app/pages/psf/share/shared/types';
import type { ShareActionsOptions } from 'src/app/shared/hooks/share';

import { useCreateNewShare } from './useCreateNewShare';
import { useRedirect } from './useRedirect';
import { useTrackPromotionShare } from './useTrackPromotionShare';

export function useOnShareSuccess(): NonNullable<ShareActionsOptions<ShareChannel>['onSuccess']> {
	const [, { toggleShared }] = usePsfSharePageState();

	const trackPromotionShare = useTrackPromotionShare();
	const createNewShare = useCreateNewShare();
	const redirect = useRedirect();

	return useCallback(
		async (channel) => {
			// awaiting to make sure it's done before navigating
			await Promise.all([trackPromotionShare(), createNewShare(channel)]);

			redirect(channel);

			toggleShared(true);
		},
		[toggleShared, trackPromotionShare, createNewShare, redirect],
	);
}
